/* Centralized PostHog event name constants.
   Use these with posthog.capture() for consistent event naming. */

import type { PostHog } from "posthog-js";

export const Events = {
  // Navigation
  PAGE_VIEW: "page_view",

  // Sources
  SOURCE_ADDED: "source_added",
  SOURCE_DELETED: "source_deleted",
  SOURCE_REFRESHED: "source_refreshed",

  // Feed Items
  ITEM_VIEWED: "item_viewed",
  ITEM_OPENED: "item_opened",
  ITEM_COMPLETED: "item_completed",
  ITEM_ARCHIVED: "item_archived",
  ITEM_BOOKMARKED: "item_bookmarked",
  ITEM_SCHEDULED: "item_scheduled",
  ITEM_RESCHEDULED: "item_rescheduled",
  ITEM_QUEUED: "item_queued",
  ITEM_SHELVED: "item_shelved",
  ITEM_DELETED: "item_deleted",

  // Content creation
  SINGLE_ITEM_ADDED: "single_item_added",
  BOOK_ADDED: "book_added",
  MOVIE_ADDED: "movie_added",
  TV_SHOW_ADDED: "tv_show_added",
  PLAYLIST_ADDED: "playlist_added",

  // AI Features
  AI_AUTOPLAN_USED: "ai_autoplan_used",
  AI_AUTOPLAN_SUCCESS: "ai_autoplan_success",
  AI_AUTOPLAN_FAILED: "ai_autoplan_failed",
  AI_CHAT_MESSAGE_SENT: "ai_chat_message_sent",
  AI_CHAT_FEEDBACK: "ai_chat_feedback",

  // Player/Reader
  PODCAST_PLAY_STARTED: "podcast_play_started",
  PODCAST_COMPLETED: "podcast_completed",

  // Tags & Goals
  TAG_CREATED: "tag_created",
  TAG_APPLIED: "tag_applied",
  TAG_GOAL_SET: "tag_goal_set",

  // Settings
  SETTINGS_CHANGED: "settings_changed",
  THEME_CHANGED: "theme_changed",

  // Subscription
  CHECKOUT_STARTED: "checkout_started",
  SUBSCRIPTION_PORTAL_OPENED: "subscription_portal_opened",

  // Authentication
  USER_SIGNED_IN: "user_signed_in",
  USER_SIGNED_OUT: "user_signed_out",
  USER_SIGNED_UP: "user_signed_up",
} as const;

export function trackEvent(
  posthog: PostHog | null | undefined,
  eventName: string,
  properties?: Record<string, unknown>,
) {
  if (!posthog?.__loaded) return;
  posthog.capture(eventName, properties);
}
